module.exports = new Promise(resolve => {
            const script = document.createElement('script');
            script.src = window.servicejob_management_url || "https://osjm.sbx.test.servicebench.com/remoteEntry.js";
            script.onerror = (args) => {
              const proxy = {
                get: request => Promise.resolve().then(() =>()=> ({})),
                init: arg => {}
              };
              resolve(proxy);
            }
            script.onload = (args) => {
              const proxy = {
                get: request => window.servicejob_management.get(request),
                init: arg => {
                  try {
                    return window.servicejob_management.init(arg);
                  } catch (e) {
                    console.log('servicejob_management has already been loaded');
                  }
                }
              };
              resolve(proxy);
            };
            document.head.appendChild(script);
          });